import React from 'react';
import L from 'leaflet';
import {
  LOOT_CLIENT_FRESH_AGE_MS,
  LOOT_MAX_ACCURACY_METERS,
  LOOT_RADIUS_METERS,
} from '../../game-map/locationPolicy.mjs';

export const PICKUP_RADIUS_METERS = LOOT_RADIUS_METERS;
export const PICKUP_MAX_ACCURACY_METERS = LOOT_MAX_ACCURACY_METERS;
export const PICKUP_MAX_POSITION_AGE_MS = LOOT_CLIENT_FRESH_AGE_MS;
export const PFAND_NAEHE_M = PICKUP_RADIUS_METERS;

export const CATEGORY_ICONS = {
  'Mülleimer': 'https://app.pfandpirat.com/wp-content/uploads/Lootfass.png',
  'Supermarkt': 'https://app.pfandpirat.com/wp-content/uploads/Handelsposten.png',
  'Pfandrückgabeautomat': 'https://app.pfandpirat.com/wp-content/uploads/Handelsposten.png',
  'Bushaltestelle': 'https://app.pfandpirat.com/wp-content/uploads/Hafen.png',
  'Markanter Ort': 'https://app.pfandpirat.com/wp-content/uploads/Markanter-Ort.png',
  'Sehenswürdigkeit': 'https://app.pfandpirat.com/wp-content/uploads/Markanter-Ort.png',
  'Parkbank': 'https://app.pfandpirat.com/wp-content/uploads/Parkbank.png',
  'Pfandspende': 'https://app.pfandpirat.com/wp-content/uploads/pfandspende.png',
  'Zu verschenken': 'https://app.pfandpirat.com/wp-content/uploads/pfandspende.png',
};

export function getCategoryIcon(categoryName) {
  const url = CATEGORY_ICONS[categoryName];

  if (!url) {
    return L.icon({
      iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
      shadowSize: [41, 41],
    });
  }

  return L.icon({
    iconUrl: url,
    iconSize: [44, 44],
    iconAnchor: [22, 44],
    popupAnchor: [0, -44],
    className: 'pfandpirat-map-pin',
  });
}

export function renderCategoryOptions(categories) {
  const categoryList = Array.isArray(categories) && categories.length
    ? categories
    : Object.keys(CATEGORY_ICONS).map((key) => ({ name: key }));

  return categoryList.map((category) => (
    <option key={category.name || category} value={category.name || category}>
      {category.name || category}
    </option>
  ));
}
